var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutdoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3836 16.8262V24.6628H23.2002V32.4994H25.8123V27.2749H30.3836V32.4994H32.9958V16.8262C32.9958 16.105 32.4111 15.5202 31.6897 15.5202C30.9684 15.5202 30.3836 16.105 30.3836 16.8262Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61252 16.8262V24.6628H10.796V32.4994H8.18385V27.2749H3.61252V32.4994H1.00037V16.8262C1.00037 16.105 1.58513 15.5202 2.30648 15.5202C3.02775 15.5202 3.61252 16.105 3.61252 16.8262Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8579 22.0512H10.1439C9.42253 22.0512 8.83777 21.4664 8.83777 20.7449C8.83777 20.0237 9.42253 19.4389 10.1439 19.4389H23.8577C24.5791 19.4389 25.1639 20.0237 25.1639 20.7449C25.1639 21.4664 24.5792 22.0512 23.8579 22.0512Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2999 22.0513H15.6877V32.5H18.2999V22.0513Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 8.98898V19.4377",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67783 10.9492H3.65616C2.18941 10.9492 1.00037 9.76016 1.00037 8.29347V5.07182H6.33356V8.29347C6.33356 9.76016 5.14452 10.9492 3.67783 10.9492Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00437 10.9492C7.53161 10.9492 6.33777 9.75535 6.33777 8.28261V5.07182H11.6709V8.28261C11.6709 9.75535 10.4771 10.9492 9.00437 10.9492Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3401 10.9492H14.3185C12.8517 10.9492 11.6627 9.76016 11.6627 8.29347V5.07182H16.9959V8.29347C16.9959 9.76016 15.8067 10.9492 14.3401 10.9492Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6777 10.9492H19.6561C18.1892 10.9492 17.0002 9.76016 17.0002 8.29347V5.07182H22.3335V8.29347C22.3333 9.76016 21.1444 10.9492 19.6777 10.9492Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0043 10.9492C23.5316 10.9492 22.3376 9.75535 22.3376 8.28261V5.07182H27.6709V8.28261C27.6709 9.75535 26.477 10.9492 25.0043 10.9492Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3399 10.9492H30.3183C28.8515 10.9492 27.6626 9.76016 27.6626 8.29347V5.07182H32.9957V8.29347C32.9957 9.76016 31.8066 10.9492 30.3399 10.9492Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9996 5.07133L30.3873 0.5H3.61252L1.00037 5.07133",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoor);
export default __webpack_public_path__ + "static/media/outdoor.58fdf8345166e9f2fb38b8d7462cf974.svg";
export { ForwardRef as ReactComponent };